import React from 'react'
import PropTypes from 'prop-types'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import COLORS from '@/checkout-instore-legacy/constants/Colors'
import { addressShape } from '@/checkout-instore-legacy/shipping/shapes'

function AddressBox(props) {
  const {
    isSelected,
    onClick,
    address: { city, postalCode, number, state, street, neighborhood },
  } = props
  const DOT_SEPARATOR = ' · '
  const TRACE_SEPARATOR = ' - '
  const ICON_SIZE = 16

  return (
    <div
      className={`address-box pointer mt1 ba br3 bw1 pa1 ${
        isSelected ? 'b--action-primary' : 'b--white'
      }`}
      onClick={onClick}
    >
      <div
        className={`flex ba br2 b--light-gray ph5 pv4 f6 lh-copy ${
          !isSelected && 'hover-b--gray'
        }`}
      >
        <div className="pr2">
          <span>
            <Icon type="nc-location" size={ICON_SIZE} color={COLORS.ON_BASE} />
          </span>
        </div>
        <div className="pl1">
          <div>
            <span className="address-box__street">{street}</span>
            <span className="address-box__number">{`, ${number}`}</span>
          </div>
          <div>
            <span className="address-box__neighborhood">{neighborhood}</span>
            {DOT_SEPARATOR}
            <span className="address-box__city">{city}</span>
            {TRACE_SEPARATOR}
            <span className="address-box__state">{state}</span>
          </div>
          <div>
            <span className="address-box__postalCode">{postalCode}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

AddressBox.propTypes = {
  address: addressShape,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
}

export default AddressBox
